import moment from "moment";

const originYear = 2016;
const currentYear = moment().year();

export const yearsList = [];

for (let i = originYear; i <= currentYear; i++) {
  yearsList.push(i);
};
